import React from 'react';
import { token } from '@atlaskit/tokens';

const primaryColor = token('color.icon');
const baseColor = token('color.background.neutral');

export const RestrictedIcon = () => (
	<svg
		width="32"
		height="32"
		viewBox="0 0 32 32"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		aria-hidden="true"
	>
		<rect width="32" height="32" fill={baseColor} fillOpacity="0.01" />
		<path
			d="M11.3787 14.8383C14.0955 14.8383 16.2978 12.6359 16.2978 9.91913C16.2978 7.20237 14.0955 5 11.3787 5C8.66194 5 6.45957 7.20237 6.45957 9.91913C6.45957 12.6359 8.66194 14.8383 11.3787 14.8383Z"
			fill={primaryColor}
		/>
		<path
			d="M4 18.5276C4 17.1687 5.10926 16.0681 6.47064 16.0681H15.969C15.4547 16.5605 15.0457 17.2473 14.9413 18.1672V24.8356C14.9302 25.3213 15.1316 26.0127 15.5436 26.6403C11.2021 27.8022 4 26.9205 4 23.9952V18.5276Z"
			fill={primaryColor}
		/>
		<path
			d="M22.4636 22.8543C21.7176 22.8543 21.1128 22.2495 21.1128 21.5035C21.1128 20.7574 21.7176 20.1526 22.4636 20.1526C23.2097 20.1526 23.8145 20.7574 23.8145 21.5035C23.8145 22.2495 23.2097 22.8543 22.4636 22.8543Z"
			fill={primaryColor}
		/>
		<path
			d="M22.5 12C24.1832 12 25.5573 13.3098 25.639 14.9558L25.6429 15.1111V16.6667H26.4286C27.257 16.6667 27.9357 17.3012 27.9957 18.1061L28 18.2222V24.4444C28 25.2645 27.359 25.9364 26.5458 25.9957L26.4286 26H18.5714C17.743 26 17.0643 25.3654 17.0043 24.5605L17 24.4444V18.2222C17 17.4022 17.641 16.7303 18.4542 16.6709L18.5714 16.6667H19.3571V15.1111C19.3571 13.445 20.6803 12.0847 22.3431 12.0038L22.5 12ZM26.4286 18.2222H19.5714C19.0191 18.2222 18.5714 18.6699 18.5714 19.2222V24.4444H25.4286C25.9809 24.4444 26.4286 23.9967 26.4286 23.4444V18.2222ZM22.5 13.5556C21.6716 13.5556 20.9929 14.1901 20.9329 14.995L20.9286 15.1111V16.6667H24.0714V15.1111C24.0714 14.3321 23.4929 13.6868 22.7379 13.5733L22.6173 13.5598L22.5 13.5556Z"
			fill={primaryColor}
		/>
	</svg>
);

export const OpenIcon = () => (
	<svg
		width="32"
		height="32"
		viewBox="0 0 32 32"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		aria-hidden="true"
	>
		<rect width="32" height="32" fill={baseColor} fillOpacity="0.01" />
		<path
			d="M11.3787 14.8383C14.0955 14.8383 16.2978 12.6359 16.2978 9.91913C16.2978 7.20237 14.0955 5 11.3787 5C8.66194 5 6.45957 7.20237 6.45957 9.91913C6.45957 12.6359 8.66194 14.8383 11.3787 14.8383Z"
			fill={primaryColor}
		/>
		<path
			d="M4 18.5276C4 17.1687 5.10926 16.0681 6.47064 16.0681H15.969C15.4547 16.5605 15.0457 17.2473 14.9413 18.1672V24.8356C14.9302 25.3213 15.1316 26.0127 15.5436 26.6403C11.2021 27.8022 4 26.9205 4 23.9952V18.5276Z"
			fill={primaryColor}
		/>
		<path
			d="M22.9847 16.8962C24.6782 16.8962 24.9725 16.8942 26.4166 16.8922C27.2501 16.8922 27.933 17.519 27.9934 18.3144L27.9977 18.4291V24.578C27.9977 25.3884 27.3527 26.0524 26.5346 26.111L26.4166 26.1153H18.5108C17.6773 26.1153 16.9944 25.4882 16.934 24.6927L16.9297 24.578V18.4291C16.9297 17.6187 17.5747 16.9548 18.3928 16.8961L18.5108 16.8919H19.3014L20.5436 16.8961C22.4637 16.8919 20.3805 16.8955 22.021 16.8919L22.9847 16.8962ZM26.4166 18.4291H19.5108C18.9586 18.4291 18.5108 18.8768 18.5108 19.4291V24.578H25.4166C25.9689 24.578 26.4166 24.1303 26.4166 23.578V18.4291Z"
			fill={primaryColor}
		/>
		<path
			d="M22.4636 22.8543C21.7176 22.8543 21.1128 22.2495 21.1128 21.5035C21.1128 20.7574 21.7176 20.1526 22.4636 20.1526C23.2097 20.1526 23.8145 20.7574 23.8145 21.5035C23.8145 22.2495 23.2097 22.8543 22.4636 22.8543Z"
			fill={primaryColor}
		/>
		<path
			d="M19.4902 13.8037C19.4906 12.9696 19.8106 12.1697 20.3798 11.5797C20.9489 10.9897 21.7209 10.6579 22.526 10.657C22.9248 10.657 23.3197 10.7384 23.6881 10.8966C24.0566 11.0548 24.3913 11.2866 24.6732 11.5788C24.9551 11.871 25.1787 12.2179 25.3312 12.5997C25.4837 12.9814 25.5621 13.3906 25.5619 13.8037V14.1953H24.0439V13.8037C24.044 13.5971 24.0049 13.3925 23.9286 13.2016C23.8524 13.0106 23.7406 12.8371 23.5997 12.691C23.4587 12.5448 23.2914 12.4288 23.1072 12.3497C22.9229 12.2705 22.7255 12.2297 22.526 12.2296C21.6897 12.2296 21.0081 12.9357 21.0081 13.8037V17.7335H19.4902V13.8037ZM24.0439 14.1953H25.5619C25.5619 14.4038 25.4819 14.6038 25.3396 14.7513C25.1972 14.8987 25.0042 14.9816 24.8029 14.9816C24.6016 14.9816 24.4086 14.8987 24.2662 14.7513C24.1239 14.6038 24.0439 14.4038 24.0439 14.1953Z"
			fill={primaryColor}
		/>
	</svg>
);
